module.exports = __webpack_public_path__ + "static/media/product.d949662c.jpg";